let mobileResolution = 768;
let noteResolution = 1400;
let prevMobile = false;
let inMobile = false;
let changeOrientation = function () {};
function updateRes() {
  prevMobile = inMobile;
  inMobile = window.innerWidth <= mobileResolution;
  window.inMobile = inMobile;
  let cl = document.body.classList;
  if (!inMobile) {
    cl.add('desktop');
    cl.remove('mobile');
    if (window.innerWidth <= noteResolution) cl.add('note');
    else cl.remove('note');
  }
  else {
    cl.add('mobile');
    cl.remove('desktop');
    cl.remove('note');
  }
  if (prevMobile !== inMobile) changeOrientation();
}
updateRes();
window.addEventListener('resize',updateRes);

if (/Edge\/|Trident\/|MSIE /.test(window.navigator.userAgent)) document.body.classList.add('ie');